/**
 * Created by neo on 08.02.17.
 */
import { MediaInfo } from './MediaInfo';

export type MediaSize = {
  url: string;
  size?: string;
  mediaInfo: MediaInfo;
};

/** @deprecated Use raw object instead */
export function createMediaSize(json?: Partial<MediaSize>): MediaSize {
  return {
    url: json?.url ?? '',
    size: json?.size,
    mediaInfo: json?.mediaInfo ?? {},
  };
}
